// Treeshaking safe.
const MediaType = function MediaType() {};
MediaType.NONE = 0;
MediaType.AUDIO = 1;
MediaType.VIDEO = 2;
export default MediaType;
